import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PpcEyebrow } from '@design-system/eyebrow/eyebrow';
import { PpcHeading } from '@design-system/heading/heading';

@Component({
  selector: 'app-info',
  imports: [TranslatePipe, PpcEyebrow, PpcHeading],
  templateUrl: './info.html',
  styleUrl: './info.css',
})
export class InfoComponent {
  private readonly translate = inject(TranslateService);
  private readonly sanitizer = inject(DomSanitizer);

  protected readonly mapUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    this.translate.instant('company.mapEmbed'),
  );

  private readonly rawHours = toSignal(this.translate.stream('company.hours'), {
    initialValue: [] as { day: string; hours: string; closed: boolean }[],
  });

  /* company.hours runs Monday to Sunday; Date#getDay counts from Sunday. */
  private readonly DAYS_PER_WEEK = 7;
  private readonly todayIndex = (new Date().getDay() + this.DAYS_PER_WEEK - 1) % this.DAYS_PER_WEEK;

  protected readonly hours = computed(() =>
    this.rawHours().map((hour: { day: string; hours: string; closed: boolean }, index: number) => ({
      ...hour,
      ranges: hour.hours.split('·').map((range: string) => range.trim()),
      today: index === this.todayIndex,
    })),
  );

  private readonly phoneHrefValue = toSignal(this.translate.stream('company.phoneHref'), { initialValue: '' });

  protected readonly phoneHref = computed(() => `tel:${this.phoneHrefValue()}`);
}
